import { useQuery } from '@tanstack/react-query';

import PriceParrotService from '~/services/PriceParrotService';

import type { ChainLpcLppSupplierSortMode } from '~/types/services/priceParrot';

import { chainLpcLppSupplierQueryKeys } from './chainLpcLppSupplierQueryKeys';

export function useGetChainLpcLppSupplierBreakdown(
  chainName: string | undefined,
  dateFrom: string | undefined,
  dateTo: string | undefined,
  sort: ChainLpcLppSupplierSortMode,
  offerBk?: string | null,
) {
  return useQuery({
    queryKey: chainLpcLppSupplierQueryKeys.breakdown(
      chainName ?? '',
      dateFrom ?? '',
      dateTo ?? '',
      sort,
      offerBk ?? null,
    ),
    queryFn: async ({ signal }) => {
      if (!chainName || !dateFrom || !dateTo) {
        throw new Error('Chain LPC-LPP supplier breakdown requires chainName, dateFrom, and dateTo');
      }
      const res = await PriceParrotService.getParityTrendChainLpcLppSuppliers(
        chainName,
        {
          date_from: dateFrom,
          date_to: dateTo,
          sort,
          offer_bk: offerBk || undefined,
        },
        signal,
      );
      return res.data;
    },
    enabled: Boolean(chainName && dateFrom && dateTo),
  });
}
